import { Box, useTheme } from '@mui/material';

export const BackgroundEffects = () => {
  const theme = useTheme();

  const dotColor = theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)';

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        zIndex: -1,
        pointerEvents: 'none',
      }}
    >
      {/* Gradient Blobs */}
      <Box
        sx={{
          position: 'absolute',
          top: '10%',
          left: '20%',
          width: '30%',
          height: '30%',
          bgcolor: 'primary.main',
          opacity: theme.palette.mode === 'dark' ? 0.1 : 0.06,
          borderRadius: '50%',
          filter: 'blur(100px)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '20%',
          right: '10%',
          width: '40%',
          height: '40%',
          bgcolor: 'secondary.main',
          opacity: theme.palette.mode === 'dark' ? 0.15 : 0.08,
          borderRadius: '50%',
          filter: 'blur(120px)',
        }}
      />

      {/* Dot Grid Pattern */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          height: '100%',
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='1' cy='1' r='1' fill='${encodeURIComponent(dotColor)}'/%3E%3C/svg%3E")`,
          opacity: 0.3,
        }}
      />
    </Box>
  );
};
